import { create } from "zustand";
import { persist } from "zustand/middleware";

import { Module } from "@/types/tenant";

import {
  createTenantChangeListener,
  createTenantStorage,
} from "./tenant-storage-helpers";

const MAX_STORED_IDS = 3; // Maximum number of IDs to store per module

interface ModuleViewedState {
  [module: string]: number[]; // array of viewed toast IDs per module
}

interface SystemToasterState {
  viewedIds: ModuleViewedState;
  updateViewedIds: (module: Module | "SYSTEM", toastId: number) => void;
  getViewedIds: () => ModuleViewedState;
  clearViewedIds: () => void;
}

export const useSystemToasterStore = create<SystemToasterState>()(
  persist(
    (set, get) => ({
      viewedIds: {},

      updateViewedIds: (module: Module | "SYSTEM", toastId: number) => {
        set((state) => {
          // Keep only the most recent MAX_STORED_IDS for the specific module
          const existingIds = state.viewedIds[module] || [];
          const uniqueIds = Array.from(new Set([...existingIds, toastId]));
          const updatedIds = uniqueIds.slice(-MAX_STORED_IDS);

          return {
            ...state,
            viewedIds: {
              ...state.viewedIds,
              [module]: updatedIds,
            },
          };
        });
      },

      getViewedIds: () => {
        const state = get();
        return state.viewedIds;
      },

      clearViewedIds: () => {
        set(() => ({
          viewedIds: {},
        }));
      },
    }),
    {
      name: "system-toast-viewed",
      partialize: (state) => ({
        viewedIds: state.viewedIds,
      }),
      storage: createTenantStorage(),
    },
  ),
);

createTenantChangeListener("system-toast-viewed", (tenantData) => {
  useSystemToasterStore.setState({
    viewedIds: tenantData.viewedIds || {},
  });
});
